export default __webpack_public_path__ + "static/media/authenticated bkg.dc8f3258.jpg";